import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, useDisclosure, useToast } from "@chakra-ui/react"
import React from "react"
import { useMutation, useQueryClient } from "react-query"
import { api } from "../../../services/api"

export function AlertDelete({ id, isApproved }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async () => {
      try {
        await api.delete(`/site/v2/crm-controle/deletar-curriculo/${id}`)
      } catch (error) {
        throw new Error(error)
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('curriculos-vendedores')
      onClose()
      toast({
        title: 'Currículo deletado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  async function handleDelete() {
    try {
      await mutateAsync()
    } catch (error) {
      toast({
        title: 'Erro ao deletar currículo',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }


  return (
    <>
    <Button
      colorScheme="red"
      size="sm"
      onClick={onOpen}
      disabled={isApproved}
      >
        Dispensar
    </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Deletar Currículo
            </AlertDialogHeader>

            <AlertDialogBody>
              Tem certeza que deseja deletar o currículo? Você não poderá desfazer essa ação posteriormente.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button 
                colorScheme='red' 
                ml={3}
                isLoading={isLoading}
                onClick={handleDelete}
              >
                Deletar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}